<template>
  <el-row
    id="home"
    style="width: 1176px;"
  >
    <el-row>
      <el-col
        :span="24"
        class="padding_30px_bottom"
        v-loading="loading"
      >
        <el-row class="padding_20px_bottom">
          <el-col
            :span="18"
            class="home_title"
          >
            <div class="font_title_email">{{ account }}</div>
            <div class="img_logo" />
            <div class="font_title_bold">欢迎登录晨星客户端</div>
          </el-col>
          <el-col
            :span="5"
            class="logout"
            @click.native="logoutAccount"
          >[退出登录]</el-col>
        </el-row>
        <el-row><br />
          <div class="select_function padding_20px_bottom">
            请选择以下功能
          </div>
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_suitability padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleSuitability"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      销售适当性
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">提供全市场基金定期更新的风险等级数据，同时包括方法论说明、基金公司审慎调查报告以及基金风险评价报告
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>

          <el-col
            :span="8"
            class="home_box"
          >
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_rank padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleRanking"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      基金排行榜
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">基于晨星独有的分类方法及数据支持，针对中国市场基金定期更新中长期业绩排行榜
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_module padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleMorningstarAward"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      晨星基金奖
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">年度基金奖是晨星基金评价体系的重要组成部分，对长期业绩表现突出且当年度获得良好回报的国内基金管理团队给予肯定

                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 60px;">
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_manager padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleManagerTagging"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      基金经理分析
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">定量与定性结合分析基金经理的管理规模、任职回报、风格标签与持仓偏好等
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_evaluate padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleCompanyEvaluate"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      基金公司分析
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">从管理规模、资金流、产品线、综合业绩、管理团队等量化数据维度对中国公募基金管理人进行分析
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
          <el-col
            :span="8"
            class="home_box"
          >
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_assetAllocation padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handlePortfolio"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      组合风险评价
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">晨星组合风险评价根据持仓基金穿透到底层的实际资产分布确定持仓风险，同时结合组合过往的业绩风险指标综合确定
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
        </el-row>

        <el-row style="padding-top: 60px;">
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_diagnosis padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handlePortfolioAnalyst"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      组合诊断
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">支持组合层面的业绩回测、资产分布与风格分析，也包括对持仓基金的业绩、风险、相关性以及管理人等维度指标
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_analysis padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleAnalyst"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      定性评级
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">晨星基金定性评级具备前瞻性分析，晨星分析师对入围基金分别给予金牌、银牌、铜牌以及中性评价
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="home_box">
              <el-card
                shadow="hover"
                class="home_background_settings padding_20px_bottom"
                style="border-radius: 30px;"
                @click.native="handleInformation"
              >
                <el-col class="home_padding_top">
                  <el-row>
                    <el-col class="home_list_title">
                      账户管理
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col class="home_list_content">设置您的账号名称、登录邮箱、密码和联系方式等，并且查看您的服务权限
                    </el-col>
                  </el-row>
                </el-col>
              </el-card>
            </div>
          </el-col>
        </el-row>

      </el-col>
    </el-row><br />
  </el-row>
</template>
<script>

import { getRole, getInfo } from "../../api/user";
import { Message } from "element-ui";
import {
  getFundReportsStatus,
  deleteFundReportsStatus
} from "../../../../cb-components-suitability/src/api/suitability";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const logout=componentsCommon.common.logout;

export default {
    data() {
        return {
            loading: false,
            account: "",
            suitability: false,            
            ranking: false,
            portfolio: false,
            analyst: false,
            analystPlatinum: false,
            evaluate: false,     
            managerTagging: false,      
            information: false,
        };
  },
  methods: {
    async pollDownloadLink() {
      const maxTime = 15 * 60 * 1000; // 15分钟
      const pollInterval = 60000; // 1分钟
      let elapsed = 0;
      let pollResult = null;

      // 第一次立即查询
      try {
        const pollRes = await getFundReportsStatus();
        if (pollRes && pollRes.data && pollRes.data.data && pollRes.data.data.zipUrl) {
          pollResult = pollRes.data.data;
        }
      } catch (e) {
        console.log('[打点] 轮询异常', e);
      }

      // 如果没查到，再进入轮询
      while (!pollResult && elapsed < maxTime) {
        await new Promise(resolve => setTimeout(resolve, pollInterval));
        elapsed += pollInterval;
        try {
          const pollRes = await getFundReportsStatus();
          if (pollRes && pollRes.data && pollRes.data.data && pollRes.data.data.zipUrl) {
            pollResult = pollRes.data.data;
            break;
          }
        } catch (e) {
          console.log('[打点] 轮询异常', e);
        }
      }

      if (pollResult && pollResult.zipUrl && !this.showDownloadLinkMessage) {
        this.downloadLink = "https://res.morningstar.cn/" + pollResult.zipUrl;
        this.showDownloadLinkMessage = true;
        Message.closeAll();
        window.closeDownloadMessage = () => {
          this.closeDownloadMessage();
        };
        Message({
          dangerouslyUseHTMLString: true,
          message: `<span>下载链接生成完毕，请点击 <a href='${this.downloadLink}' target='_blank' style='color:#409EFF;font-weight:bold;' onclick="window.closeDownloadMessage()">下载报告压缩包</a></span>`,
          duration: 0,
          showClose: true
        });
      }
    },

    async closeDownloadMessage() {
      Message.closeAll();
      // 删除状态文件
      try {
        const match = this.downloadLink.match(/fundReports_(.+?)\.zip/);
        console.log('[打点] downloadLink:', this.downloadLink, 'match:', match);
        const key = match ? match[1] : '';
        const userStatusPath = `res/solution/userStatus/${key}.json`;
        console.log('[打点] 用户点击下载，删除状态文件参数', userStatusPath);
        const resp = await deleteFundReportsStatus({ key: userStatusPath });
        console.log('[打点] 删除状态文件结果', resp);
      } catch (e) {
        Message({
          message: "删除状态文件失败！" + (e.message || ''),
          type: "error",
          duration: 3 * 1000
        });
        console.log('[打点] 删除状态文件异常', e);
      }
    },
        logoutAccount() {
            let self = this;
            logout(self);
        },
        loadUserData() {
            let self = this;
            let userInfo = getNameAndValue("info");
            self.loading = true;
            if (userInfo != undefined && userInfo != null && userInfo != "") {
                self.configRole(JSON.parse(userInfo));
                //console.log("user::::"+userInfo)
                self.loading = false;
            } else {
                getRole()
                    .then((response) => {
                        let result = response.data;
                        if (result == undefined) {
                            Message({
                                message: "数据异常，请尝试刷新再试！",
                                type: "error",
                                duration: 2 * 1000,
                            });
                            Message.close = function () {};
                        } else {
                            if (checkResponseStatus(result, self)) {
                                userInfo = result.data;
                                setNameAndValue("info", userInfo);
                                setNameAndValue("id", userInfo.clientId);
                                self.configRole(userInfo);
                            }
                        }
                    })
                    .catch((x) => {
                        Message({
                            message:
                                "获取权限失败，如需开通请联系对应销售人员或chinamarketing@morningstar.com",
                            type: "error",
                            duration: 3 * 1000,
                        });
                        Message.close = function () {};
                    })
                    .finally((r) => {
                        self.loading = false;
                    });
            }
        },
        handleSuitability() {
            let self = this;
            if (self.suitability) {
                self.$router.push({
                    path: "/Suitability",
                });
            } else {
                self.handleMessage();
            }
        },
        handleCompanyEvaluate() {
            let self = this;
            if (self.evaluate) {
                self.$router.push({
                    path: "/company-evaluate",
                });
            } else {
                self.handleMessage();
            }
        },
        handleManagerTagging() {
            let self = this;
            if (self.managerTagging) {
                self.$router.push({
                    path: "/manager-tagging",
                });
            } else {
                self.handleMessage();
            }
        },
        handleMorningstarAward() {
          let self = this;
          self.$router.push({
              path: "/morningstar-award",
          });
        },
        handlePortfolio() {
            let self = this;
            if (self.portfolio) {
                self.$router.push({
                    path: "/portfolio",
                });
            } else {
                self.handleMessage();
            }
        },
        handleRanking() {
            let self = this;
            if (self.ranking) {
                self.$router.push({
                    path: "/Ranking",
                });
            } else {
                self.handleMessage();
            }
        },
        handleAnalyst() {
            let self = this;
            if (self.analyst || self.analystPlatinum) {
                self.$router.push({
                    path: "/Analyst-Rating",
                });
            } else {
                self.handleMessage();
            }
        },
        handleInformation() {
            let self = this;
            if (self.information) {
                self.$router.push({
                    path: "/Information",
                });
            } else {
                self.handleMessage();
            }
        },
        handlePortfolioAnalyst() {
            let self = this;
            // if (self.portfolio) {
                self.$router.push({
                    path: "/portfoliodiagnostic",
                });
            // } else {
            //     self.handleMessage();
            // }
        },
        configRole(userInfo) {
            let self = this;
            if (userInfo) {
                if (userInfo.suitability && userInfo.suitability!=0 
                    && (userInfo.suitabilityMemberBaseTrial || userInfo.suitabilityMemberBase || userInfo.suitabilityMemberSeniorTrial || userInfo.suitabilityMemberSenior)) {
                    self.suitability = true;
                }

                if (userInfo.ranking && userInfo.ranking!=0 
                    && (userInfo.rankingMemberBaseTrial || userInfo.rankingMemberBase || userInfo.rankingMemberSeniorTrial || userInfo.rankingMemberSenior)) {
                    self.ranking = true;
                }

                if (userInfo.analystRating && userInfo.analystRating!=0 
                    && (userInfo.analystRatingMemberBaseTrial ||userInfo.analystRatingMemberBase)) {
                    self.analyst = true;
                }
                if (userInfo.analystRating && userInfo.analystRating!=0 
                    && (userInfo.analystRatingMemberSeniorTrial || userInfo.analystRatingMemberSenior)) {
                    self.analystPlatinum = true;
                }

                if (userInfo.portfolioSuitability && userInfo.portfolioSuitability!=0
                    && (userInfo.portfolioSuitabilityMemberBaseTrial || userInfo.portfolioSuitabilityMemberBase || userInfo.portfolioSuitabilityMemberSeniorTrial || userInfo.portfolioSuitabilityMemberSenior)) {
                    self.portfolio = true;
                }

                if (userInfo.fundSelection && userInfo.fundSelection!=0
                    && (userInfo.fundSelectionMemberBaseTrial || userInfo.fundSelectionMemberBase)) {
                    self.evaluate = true;
                }

                if (userInfo.managerTagging && userInfo.managerTagging!=0
                    && (userInfo.managerTaggingMemberBaseTrial || userInfo.managerTaggingMemberBase)) {
                    self.managerTagging = true;
                }

                if (userInfo.information) {
                    self.information = true;
                }
                self.account = userInfo.email;
            }
        },
        handleMessage() {
            Message({
                message:
                    "服务暂未授权<br>如需开通请联系对应销售人员或chinamarketing@morningstar.com",
                dangerouslyUseHTMLString: true,
            });
        },
        handleMessage2() {
            Message({
                message:
                    "<strong>即将上线</strong>",
                dangerouslyUseHTMLString: true,
            });
        }
    },
    mounted() {
        //this.loadFundCache();
      this.loadUserData();
      this.pollDownloadLink();
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/home";

.font_title_bold {
  margin-top: 10px;
}

</style>